//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    label: { // 柱子左侧的文本
      type: String, default: ''
    },
    labelSty: { // 柱子左侧文本的样式
      type: [String, Object], default: ''
    },
    bar1: {
      type: [Number, String], default: 50
    },
    bar2: {
      type: [Number, String], default: 0
    },
    minNum: { // 柱子的宽度过短时，小于指定值时不展示文本
      type: [Number, String], default: 6
    },
    customFun: { // 自定义函数
      type: [String, Function], default: ''
    }
  },
  data () {
    return {
      bar1Width: 100, // 第一个柱子的长度
      bar2Width: 0 // 第二个柱子的长度
    }
  },
  watch: {
    bar1 () {
      this.init()
    }
  },
  created () {
    this.init()
  },
  methods: {
    // 页面初始化
    init () {
      this.bar1Width = this.bar1
      this.bar2Width = this.bar2
      if (this.customFun) {
        const { redItem = 0, greenItem = 0 } = this.customFun(this.bar1, this.bar2) // 排除柱子过短时，文字显示不下的情况
        this.bar1Width = redItem
        this.bar2Width = greenItem
      }
    }
  }
}
